export default __webpack_public_path__ + "cover_silver.57584e20.png";